import React from 'react';

const Button = ({ text, onClick, type = 'button', disabled = false, className = '' }) => {
  const fallbackStyle = {
    backgroundColor: '#680805',
    color: '#ffffff',
    borderColor: '#4f0604',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={fallbackStyle}
      className={`btn-primary rounded-xl px-6 py-3 text-sm font-semibold text-white focus:outline-none disabled:cursor-not-allowed disabled:opacity-70 ${className}`}
    >
      {text}
    </button>
  );
};

export default Button;